"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bufferToEpoch = exports.groupByChannel = exports.epoch = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const constants_1 = require("../lib/constants");
/**
 * Converts a stream of individual Samples of EEG data into a stream of Epochs of a given duration emitted at specified interval. This operator functions similarly to a circular buffer internally and allows overlapping Epochs of data to be emitted (e.g. emitting the last one second of data every 100ms).
 * @method epoch
 * @example eeg$.pipe(epoch({ duration: 1024, interval: 100, samplingRate: 256 }))
 * @param {Object} options - Epoching options
 * @param {number} [options.duration=256] Number of samples to include in each epoch
 * @param {number} [options.interval=100] Time (ms) between emitted Epochs
 * @param {number} [options.samplingRate=256] Sampling rate
 * @param {string} [options.dataProp='data'] Name of the key associated with eeg data
 * @returns {Observable} Epoch
 */
exports.epoch = ({ duration = constants_1.NEUROSITY_EPOCH_DURATION, interval = constants_1.NEUROSITY_EPOCH_INTERVAL, samplingRate = constants_1.NEUROSITY_SAMPLING_RATE, dataProp = constants_1.NEUROSITY_DATA_PROP, packetThreshold = 1, } = {}) => rxjs_1.pipe(operators_1.bufferCount(interval), operators_1.scan((acc, val) => acc.concat(val).slice(acc.length < duration ? 0 : -duration)), operators_1.filter((samplesArray) => samplesArray.length === duration), exports.bufferToEpoch({ samplingRate, dataProp, packetThreshold }));
/**
 * Get a 2D data array organized by channel from an array of Samples. Credit to Ken from Seattle's elegant transposition
 * http://www.codesuck.com/2012/02/transpose-javascript-array-in-one-line.html
 * @method groupByChannel
 * @param {Array<Sample>} samplesBuffer Array of Samples to be grouped
 * @param {string} [dataProp] Name of the key associated with EEG data
 * @returns {Array<Array<number>>}
 */
//@ts-ignore
exports.groupByChannel = (samplesBuffer, dataProp = constants_1.NEUROSITY_DATA_PROP) => 
//@ts-ignore
samplesBuffer[0][dataProp].map((_, channelIndex) => samplesBuffer.map((sample) => sample[dataProp][channelIndex]));
exports.bufferToEpoch = ({ samplingRate = constants_1.NEUROSITY_SAMPLING_RATE, dataProp = constants_1.NEUROSITY_DATA_PROP, packetThreshold = 1 } = {}) => rxjs_1.pipe(operators_1.map((samplesArray) => ({
    [dataProp]: exports.groupByChannel(samplesArray, dataProp),
    packetLoss: samplesArray
        .map((sample) => sample.index)
        .slice(1)
        .map(function (n, i) {
        return n - samplesArray.map((sample) => sample.index)[i];
    })
        .reduce((accumulator, currentValue, i) => (currentValue > packetThreshold && accumulator.push({ index: i, skipped: currentValue / packetThreshold - 1 }), accumulator), []),
    info: Object.assign(Object.assign({}, samplesArray[0] && samplesArray[0].info ? samplesArray[0].info : {}), {
        startTime: samplesArray[0].timestamp,
        samplingRate: samplesArray[0].info && samplesArray[0].info.samplingRate ? samplesArray[0].info.samplingRate : samplingRate,
    }),
})));
//# sourceMappingURL=neurosity-utils.js.map